export const camo = [
  {
    number: 'C100',
    hasModel: true,
  },
  {
    number: 'C101',
    hasModel: false,
  },
  {
    number: 'C102',
    hasModel: false,
  },
  {
    number: 'C103',
    hasModel: false,
  },
  {
    number: 'C104',
    hasModel: true,
  },
  {
    number: 'C105',
    hasModel: true,
  },
  {
    number: 'C106',
    hasModel: false,
  },
  {
    number: 'C107',
    hasModel: true,
  },
  {
    number: 'C108',
    hasModel: true,
  },
  {
    number: 'C109',
    hasModel: false,
  },
  {
    number: 'C110',
    hasModel: true,
  },
  {
    number: 'C111',
    hasModel: true,
  },
  {
    number: 'C112',
    hasModel: false,
  },
  {
    number: 'C113',
    hasModel: false,
  },
  {
    number: 'C114',
    hasModel: true,
  },
  {
    number: 'C122',
    hasModel: false,
  },
  {
    number: 'C125',
    hasModel: false,
  },
  {
    number: 'C126',
    hasModel: false,
  },
  {
    number: 'C127',
    hasModel: true,
  },
  {
    number: 'C128',
    hasModel: true,
  },
  {
    number: 'C129',
    hasModel: true,
  },
  {
    number: 'C130',
    hasModel: false,
  },
  {
    number: 'C131',
    hasModel: false,
  },
  {
    number: 'C132',
    hasModel: false,
  },
  {
    number: 'C133',
    hasModel: false,
  },
  {
    number: 'C134',
    hasModel: true,
  },
  {
    number: 'CX',
    hasModel: false,
  },
];
